<template>
  <button
    @click="$emit('handle:click')"
    :class="{
      fill,
      [color]: ['primary', 'danger', 'secondary', 'success'].includes(color),
      [size]: ['small', 'medium', 'large'].includes(size),
    }"
  >
    <template v-if="text">
      {{ text }}
    </template>
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    text: {
      type: String,
    },
    fill: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: 'primary',
    },
    size: {
      type: String,
      default: 'medium',
    },
  },
}
</script>

<style lang="scss" scoped>
button {
  all: unset;
  box-sizing: border-box;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.625rem;
  cursor: pointer;

  span {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &.medium {
    height: 2.6875rem;
    padding: 0.625rem;

    font-size: 0.875rem;
    font-weight: 700;
    line-height: 19.1px;
  }

  &.small {
    padding: 0.25rem 0.5rem;

    font-size: 0.875rem;
    font-weight: 700;
    line-height: 19.1px;
  }

  &.fill {
    color: #fff;
    border: 0;
  }

  &:not(.fill) {
    background: transparent;
  }

  &.fill.danger {
    background: #e91d23;
  }

  &.fill.danger:hover:not(:disabled) {
    background: #cc1419;
  }

  &.danger:not(.fill) {
    color: #e91d23;
    border: 1px solid #e91d23;
  }

  &.danger:not(.fill):hover:not(:disabled) {
    color: #cc1419;
    border: 1px solid #cc1419;
  }

  &.fill.primary {
    background: #1c2d5a;
  }

  &.fill.primary:hover:not(:disabled) {
    background: #142552;
  }

  &.primary:not(.fill) {
    color: #1c2d5a;
    border: 1px solid #1c2d5a;
  }

  &.primary:not(.fill):hover:not(:disabled) {
    color: #142552;
    border: 1px solid #142552;
  }

  &.fill.secondary {
    background: #ffc20e;
  }

  &.fill.secondary:hover:not(:disabled) {
    background: #f8bd0d;
  }

  &.secondary:not(.fill) {
    color: #ffc20e;
    border: 1px solid #ffc20e;
  }

  &.secondary:not(.fill):hover:not(:disabled) {
    color: #f8bd0d;
    border: 1px solid #f8bd0d;
  }

  &.fill.success {
    background: #16a34a;
  }

  &.fill.success:hover:not(:disabled) {
    background: #199647;
  }

  &.success:not(.fill) {
    color: #16a34a;
    border: 1px solid #16a34a;
  }

  &.success:not(.fill):hover:not(:disabled) {
    color: #199647;
    border: 1px solid #199647;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
}
</style>
